import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import vuetify from './vuetify.js'; // can't edit locale without Vuetify being loaded, instead uses watcher in main.js

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = ['nl', 'en', 'el', 'cn']; // language imports available in @/i18n. TODO: automate with webpack context

export const i18n = new VueI18n({
  locale: 'nl',
  fallbackLocale: {
    default: ['nl', 'en'],
  },
  messages: {}, // init messages
  dateTimeFormats: {}, // init dateTimeFormats
  silentTranslationWarn: true, // https://kazupon.github.io/vue-i18n/api/#silenttranslationwarn
});

const loadedLanguages = []; // our default language that is preloaded
let fallbackLoaded = false; // Flag to track if fallback languages are loaded

async function loadFallbackLanguages() {
  fallbackLoaded = true;
  await Promise.all(i18n.fallbackLocale.default.map(f => loadLanguageAsync(f, true))); // Pass true to indicate fallback load
}

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  localStorage.setItem('locale', lang);
  return lang;
}

// TODO: Split lang into regional subimports (en-GB-cockney -> en, en-GB, en-GB-cockney) or loop through fallbacks
export async function loadLanguageAsync(lang, isFallback = false) {
  // TODO: Split lang into regional subimports (en-GB-cockney -> en, en-GB, en-GB-cockney) or loop through fallbacks
  if (!SUPPORTED_LOCALES.includes(lang) ) {
    return;
  }

  if (!fallbackLoaded && !isFallback) {
    await loadFallbackLanguages();
  }

  // If the same language and not a fallback load
  if (i18n.locale === lang && !isFallback) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded and not a fallback load
  if (loadedLanguages.includes(lang) && !isFallback) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/${lang}.js`)
    .then(t => {
      i18n.setLocaleMessage(lang, t.messages);
      i18n.setDateTimeFormat(lang, t.dateTimeFormats);
      if(!loadedLanguages.includes(lang))
        loadedLanguages.push(lang); //prevent duplicate loading

      if (isFallback) {
        for (const fallbackLang of i18n.fallbackLocale.default) {
            if (fallbackLang !== lang) {
              i18n.dateTimeFormats[lang] = Object.assign({}, i18n.dateTimeFormats[lang], t.dateTimeFormats);
            }
        }
      }
      return setI18nLanguage(lang);
    })
    .catch(err => console.log('Could not load translations', err));
}